import React, { FC } from 'react'
import { Button } from '@ucheba/ui/components/Button/desktop'

import { Dialog } from '@ucheba/ui/components/Dialog/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Divider } from '@ucheba/ui/components/Divider/desktop'
import { List } from '@ucheba/ui/components/List/desktop'
import { Box } from '@ucheba/ui/components/Box/desktop'

import Loader from '@ucheba/ui/components/Loader/desktop/Loader'
import GraduationCapIcon from '@ucheba/ui/icons/icon__graduation-cap.svg'
import GraduationCapCheckIcon from '@ucheba/ui/icons/icon__graduation-cap-check.svg'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'

import { analyticEvent } from '@ucheba/utils/helpers/analytics/events'
import {
  EAnalyticEvents,
  EAnalyticEventTargets,
  EAnalyticSections,
} from '@ucheba/utils/helpers/analytics/events/types'
import { HEAD_COLORS } from '../../constants'

import { IResultsAssessmentOfChancesProps } from '../../types'
import ProgramItem from './ProgramItem'

import { Buttons, LoaderWrapper, ProgramsBox, RestartIconStyled } from '../../styles'
import { useResultsList } from '../bll/useResultsList'
import LidMagnetForm from '../../../../../LidMagnetForm/desktop'
import {
  EApplicationFormProductTypes,
  EApplicationFunnels,
} from '../../../../../AppliactionForm/types'
import { ETypeRequest } from '../../../../../../pages/for-abiturients/ege/index/types'

const ResultsAssessmentOfChances: FC<IResultsAssessmentOfChancesProps> = (props) => {
  const {
    open = false,
    isInPlanOfAdmission,
    insitutionName,
    onClose,
    handleOpenDialog,
    handleWantToStudy,
    restartAssessmentOfChances,
    showLidForm = true,
  } = props

  const { isLoadingList, probability, title, programs, anotherPrograms } =
    useResultsList(insitutionName)

  if (!open) return null

  return (
    <Dialog
      spacing='null'
      open={open}
      onClose={onClose}
      scrollY={!!(anotherPrograms && anotherPrograms.length > 0)}
      overflow='hidden'
    >
      <Box
        radius='null'
        color={isLoadingList ? 'gray5' : HEAD_COLORS[probability].box}
        spacing='xlarge'
      >
        <Heading
          html
          color={isLoadingList ? 'gray40' : HEAD_COLORS[probability].heading}
          h2={title}
          spacing='large'
        />

        <Buttons>
          <Button
            disabled={isLoadingList}
            onClick={handleWantToStudy}
            view={isInPlanOfAdmission ? 'outline' : 'default'}
            StartIcon={
              isInPlanOfAdmission ? <GraduationCapCheckIcon /> : <GraduationCapIcon />
            }
            color={HEAD_COLORS[probability].heading}
          >
            {isInPlanOfAdmission ? 'В плане' : 'Хочу поступить'}
          </Button>

          <Button
            color={HEAD_COLORS[probability].heading}
            onClick={handleOpenDialog}
            disabled={isLoadingList}
          >
            Задать вопрос
          </Button>

          {!isLoadingList && (
            <Button
              view='link'
              color={HEAD_COLORS[probability].heading}
              EndIcon={<RestartIconStyled />}
              onClick={restartAssessmentOfChances}
            >
              Оценить шансы заново
            </Button>
          )}
        </Buttons>
      </Box>

      {isLoadingList ? (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      ) : (
        <>
          {!!programs?.length && (
            <ProgramsBox spacing='xlarge'>
              <Text fontSize='h3' lineHeight='h3' fontWeight='extrabold'>
                Подходящие программы
              </Text>

              <Divider spacing='xlarge' />

              <List spacing='xlarge'>
                {programs.map((program, key, array) => (
                  <>
                    <ProgramItem
                      key={program.id}
                      probabilityType={probability}
                      {...program}
                    />

                    {(array.length > 3 ? key === 2 : key === 1) && showLidForm && (
                      <div
                        style={{
                          width: '100%',
                          marginBottom: '16px',
                        }}
                      >
                        <LidMagnetForm
                          title='Хочешь сдать ЕГЭ на&nbsp;80+ и&nbsp;поступить в&nbsp;этот вуз на&nbsp;бюджет?'
                          text='Поможем подготовиться к&nbsp;ЕГЭ на&nbsp;высокие баллы с&nbsp;гарантией поступления в&nbsp;онлайн-школе Учеба.ру'
                          buttonText='Подготовиться к ЕГЭ'
                          funnel={EApplicationFunnels.assessment_of_chances}
                          productType={EApplicationFormProductTypes.ege}
                          requestTarget={ETypeRequest.ege_lead_request}
                          onSubmitForm={() => {
                            analyticEvent({
                              targets: [
                                EAnalyticEventTargets.ym,
                                EAnalyticEventTargets.ur,
                              ],
                              eventName: EAnalyticEvents.leadFormRequestChance,
                              section: EAnalyticSections.leadMagnetForm,
                            })
                          }}
                          list={[
                            'Расскажем о системе эффективной подготовки',
                            'Познакомим с онлайн-школой и платформой',
                            'Ответим на вопросы и запишем на занятия',
                          ]}
                        />
                      </div>
                    )}
                  </>
                ))}
              </List>
            </ProgramsBox>
          )}

          {!!anotherPrograms?.length && (
            <Box spacing='xlarge'>
              {!!programs?.length && (
                <>
                  <Divider spacing='null' />

                  <Spacing spacing='large' />
                </>
              )}

              <Text fontSize='h3' lineHeight='h3' fontWeight='extrabold'>
                Подходящие программы в других вузах
              </Text>

              <Spacing spacing='large' />

              <Divider spacing='null' />

              <Spacing spacing='xlarge' />

              <List spacing='xlarge'>
                {anotherPrograms.map((program) => (
                  <ProgramItem
                    key={program.id}
                    probabilityType={probability}
                    {...program}
                  />
                ))}
              </List>
            </Box>
          )}
        </>
      )}
    </Dialog>
  )
}

export default ResultsAssessmentOfChances
